import { render, staticRenderFns } from "./UserMiniMe.vue?vue&type=template&id=36793d63&"
import script from "./UserMiniMe.vue?vue&type=script&lang=ts&"
export * from "./UserMiniMe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36793d63')) {
      api.createRecord('36793d63', component.options)
    } else {
      api.reload('36793d63', component.options)
    }
    module.hot.accept("./UserMiniMe.vue?vue&type=template&id=36793d63&", function () {
      api.rerender('36793d63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/user/UserMiniMe.vue"
export default component.exports